import React from 'react';
import Button from '../../../Components/button';
import { DetailInfo, U } from '../../../../assets/img/svg/details';
import { CalendarFill, Clock, Local } from '../../../../assets/img/svg/icons';

const InfoBox: React.FC<{ icone: React.ReactNode, titulo: string, text: string }> = ({ icone, titulo, text}) => {
    return (
        <div className='group bg-white hover:bg-main-pink drop-shadow-sm p-4 w-full md:w-1/3 rounded-xl flex flex-col items-center gap-2 relative text-center transition-all duration-200 hover:text-white'>
            <div className='absolute left-0 top-0 w-full h-full after:content-[""] after:h-28 after:w-2 after:bg-main-blue after:rounded-lg after:absolute after:left-0 after:bottom-0 after:-z-10 before:h-2 before:w-28 before:bg-light-yellow before:rounded-lg before:absolute before:left-0 before:bottom-0 before:-z-10 transition-all duration-200 group-hover:-scale-y-100'>
                <span className='border-l-[8px] border-b-[8px] border-main-pink w-10 h-10 inline-block absolute left-0 bottom-0'></span>
            </div>

            {icone}
            <h4 className="text-xl font-semibold">{titulo}</h4>
            <p className='text-sm'>{text}</p>
        </div>
    );
};

const InfoSection: React.FC<{date: Date, inicio: string, fim: string, local: string, inscricao: string}> = ({date, inicio, fim, local, inscricao}) => {
    return (
        <section className='py-8 max-w-[1920px] mx-auto relative'>
            <U className='absolute left-1/2 md:-left-[200px] -translate-x-1/2 md:translate-x-0 top-1/2 -translate-y-1/2 -z-10 rotate-[20deg] w-[300px] md:w-[500px] h-[300px] md:h-[500px] object-contain' />
            <div className="absolute left-1/2 -translate-x-1/2 -z-20 top-20 h-[calc(100%+200px)] w-dvw">
                <DetailInfo className='object-cover h-full w-full scale-150 -translate-y-44' />
            </div>

            <div className="max-w-screen-lg 2xl:max-w-screen-xl mx-auto px-4">
                <h3 className="text-2xl text-center font-semibold">
                    Não fique de fora <br />
                    participe do evento
                </h3>

                <div className="mt-10 flex-col md:flex-row flex justify-center gap-8 max-w-screen-lg mx-auto">
                    <InfoBox 
                        icone={<CalendarFill className="h-6 w-6 object-contain transition-all duration-200 fill-main-pink group-hover:fill-white" />} 
                        titulo="Data do Evento" 
                        text={date.toLocaleDateString('pt-br')} />

                    {inicio && fim && 
                        <InfoBox 
                            icone={<Clock className="h-6 w-6 object-contain transition-all duration-200 fill-main-pink group-hover:fill-white" />} 
                            titulo="Horário" 
                            text={`${inicio} às ${fim}`} />
                    }

                    {local && 
                        <InfoBox 
                            icone={<Local className="h-6 w-6 object-contain transition-all duration-200 fill-main-pink group-hover:fill-white" />} 
                            titulo='Local' 
                            text={local} />
                    }
                </div>

                <div className="mt-14 grid md:grid-cols-3 gap-8 md:after:content-[''] md:before:content-[''] max-w-screen-lg mx-auto">
                    {inscricao &&
                        <Button text="Quero participar" link={inscricao} arrow={true} color="pink" target='_blank' />
                    }
                </div>
            </div>
        </section>
    );
};

export default InfoSection;